// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.payment-field[data-v-4b78e972] {\n  width: 100%;\n  position: relative;\n  height: 185px;\n  padding: 24px 24px 0px 24px;\n  border: 1px solid #1BA7E1;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 12px rgba(27, 167, 225, 0.15);\n  border-radius: 4px\n}\n.payment-field.left[data-v-4b78e972] {\n  height: auto;\n}\n.bank-img[data-v-4b78e972] {\n  position: absolute;\n  right: 20px;\n  bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
